module.exports = __webpack_public_path__ + "static/media/foto.e421fe19.jpg";